import myShopClient from './nearlive';

export async function createTicket(id, ticket) {
	const client = await myShopClient();
	const { data } = await client.post(`/api/hubspot/tickets/${id}`, ticket);
	return data;
}
